interface TextWidgetProps {
  data?: any
  config?: Record<string, any>
}

export function TextWidget({ data, config }: TextWidgetProps) {
  const text =
    config?.text || (data && Array.isArray(data) && data.length > 0 ? JSON.stringify(data[0], null, 2) : "No data")

  return (
    <div className="h-full overflow-auto">
      <pre className="whitespace-pre-wrap text-sm text-gray-900 dark:text-gray-100">{text}</pre>
    </div>
  )
}
